export default __webpack_public_path__ + "static/media/Inside.764ae4a5.jpeg";